module.exports = __webpack_public_path__ + "static/media/handshake-in-medical-gloves-HZ7B8GL.ccfe4a0b.png";